var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.delete,
            expression: "modalState.delete",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("delete", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "float-left" }, [
                  _vm._v("Delete Scan"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("delete", false)
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "Please confirm that you would like to delete this scan."
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c("div", { staticClass: "footer-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-cancel",
                      on: {
                        click: function ($event) {
                          return _vm.updateModal("delete", false)
                        },
                      },
                    },
                    [_vm._v("\n                    Cancel\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function ($event) {
                          return _vm.deleteScan()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-trash" }),
                      _vm._v(
                        "\n                    Delete Scan\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.cancel,
            expression: "modalState.cancel",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("cancel", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", [_vm._v("Cancel Scan")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("cancel", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "Please confirm that you would like to cancel that in-progress\n            scan."
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    on: {
                      click: function ($event) {
                        return _vm.cancelScan()
                      },
                    },
                  },
                  [_vm._v("\n                Confirm\n            ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }